import * as Actions from './actions'
import initialState from '../store/initialState'

export const RegisterReducer = (state = initialState.register, action: any) => {
    switch (action.type) {
        case Actions.SET_REGISTER_VALUE:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}